// Maps category.color tokens from design guidelines to Tailwind classes
export const COLOR_MAP = {
    primary: {
        bg: "bg-[#A7F3D0]",
        soft: "bg-[#D1FAE5]",
        text: "text-black",
        dot: "bg-[#A7F3D0]",
    },
    secondary: {
        bg: "bg-[#FDBA74]",
        soft: "bg-[#FED7AA]",
        text: "text-black",
        dot: "bg-[#FDBA74]",
    },
    accent_1: {
        bg: "bg-[#D8B4FE]",
        soft: "bg-[#EDE9FE]",
        text: "text-black",
        dot: "bg-[#D8B4FE]",
    },
    accent_2: {
        bg: "bg-[#FDE047]",
        soft: "bg-[#FEF9C3]",
        text: "text-black",
        dot: "bg-[#FDE047]",
    },
    accent_3: {
        bg: "bg-[#93C5FD]",
        soft: "bg-[#DBEAFE]",
        text: "text-black",
        dot: "bg-[#93C5FD]",
    },
};

export const getCategoryStyle = (color) =>
    COLOR_MAP[color] || COLOR_MAP.primary;

// Quick per-category color lookup (used when we only have category slug)
export const CATEGORY_COLORS = {
    "article-content": "primary",
    "story-book": "accent_1",
    "poem-lyrics": "accent_2",
    "email-letter": "secondary",
    "rewriting-editing": "accent_3",
    "business-professional": "primary",
    "education-study": "accent_1",
    "creative-fun": "accent_2",
    "coding-programming": "accent_3",
    "image-tools": "secondary",
};
